export default "__VITE_ASSET__C9xj4RF5__"